import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from './constants';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete1.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";

const FeatureItem = ({
    feature,
    groupId,
    groupIndex,
    isUngrouped,
    index,
    moveFeatureCard,
    handleFeatureEdit,
    handleFeatureDelete,
}) => {
    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.FEATURE,
        item: () => ({ id: feature._id, groupId, groupIndex: groupIndex, index, type: ItemTypes.FEATURE }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const [, drop] = useDrop({
        accept: ItemTypes.FEATURE,
        canDrop: (item) => item.type === ItemTypes.FEATURE,
        drop: (item) => {
            if (item.id === feature._id) return;
            // // Update the item's position reference
            moveFeatureCard(item.id, item.index, index, item.groupId, item.groupIndex, groupId, groupIndex, isUngrouped);
            item.index = index;
            item.groupId = groupId;
            item.groupIndex = groupIndex;

            return { dropped: true };
        }
    });

    const onEdit = () => handleFeatureEdit(feature, groupId, index);

    const onDelete = () => handleFeatureDelete(feature, groupId, index);

    return (
        <Box
            ref={(node) => drag(drop(node))}
            sx={{
                opacity: isDragging ? 0.5 : 1,
                border: "1px solid #ddd",
                borderRadius: 2,
                backgroundColor: "#f9f9f9",
                padding: '0.25rem 0.5rem',
                width: {
                    xs: "100%",
                    md: "calc(50% - 0.5rem)",
                    lg: "calc(33% - 0.5rem)"
                }
            }}
        >
            <Box sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: 1,
            }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Typography
                        sx={{
                            fontFamily: "GilroySemiBold",
                            fontSize: 12,
                            color: "black",
                        }}
                    >
                        {feature.label}
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "GilroyRegular",
                            fontSize: 10,
                            color: "#666",
                        }}
                    >
                        {feature.description}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
                    <EditIcon width={20} height={20} onClick={onEdit} />
                    <DeleteIcon width={20} height={20} onClick={onDelete} />
                </Box>
            </Box>
        </Box>
    );
};

export default FeatureItem;